module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.doPrint
    }
  }, [_vm._v(_vm._s(_vm.$props.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6cf5f2c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StockTicketsPrint.vue
// module id = 1245
// module chunks = 0